<script lang="ts">
  import { _ } from "svelte-i18n";
  import Carousel from "$lib/components/Carousel/Carousel.svelte";
  import Button from "$lib/components/Button/Button.svelte";
  import Container from "$lib/components/Container/Container.svelte";
  import { CardType, CarouselSize } from "$lib/gql/genCms/codegen";
  import cfg from "$lib/config/config";

  import { transformNostoRecsCards } from "$lib/utils/transformNostoRecs";

  import { recommendations } from "$lib/stores/recommendations";
  import type { PageType } from "$lib/stores/recommendations";
  import { regionStore } from "$lib/stores/region";
  import { get } from "svelte/store";

  export let pageType: PageType;
  let recommendationData;
  export let input;
  let cards;
  let show = false;

  function handleAttribution(productId: string) {
    recommendations.setAttribution($recommendations.resultId, productId);
    return true;
  }

  const { productId, variantId, placement, categoryPath, searchTerm } = input;

  const isBrowser = typeof window !== "undefined";

  const regionInfo = regionStore();

  const locale = get(regionInfo).locale;

  let lang = locale;
  lang = lang && lang.split("-")[0];

  $: isBrowser &&
    window.nostojs &&
    window.nostojs(api => {
      recommendations.setUser();
      recommendations.setCart();

      switch (pageType) {
        case "PDP":
          return api
            .defaultSession()
            .setResponseMode("JSON_ORIGINAL")
            .viewProductSku(
              productId?.split("/").slice(-1)[0],
              variantId?.split("/").slice(-1)[0],
            )
            .setPlacements([placement])
            .load()
            .then(
              res =>
                (recommendationData = recommendations.transformRecPlacements(
                  Object.values(res.recommendations)[0],
                  lang,
                )),
            );
        case "PLP":
          return api
            .defaultSession()
            .setResponseMode("JSON_ORIGINAL")
            .viewCategory(categoryPath)
            .setPlacements([placement])
            .load()
            .then(
              res =>
                (recommendationData = recommendations.transformRecPlacements(
                  Object.values(res.recommendations)[0],
                  lang,
                )),
            );

        case "HOME":
          return api
            .defaultSession()
            .setResponseMode("JSON_ORIGINAL")
            .viewFrontPage()
            .setPlacements([placement])
            .load()
            .then(
              res =>
                (recommendationData = recommendations.transformRecPlacements(
                  Object.values(res.recommendations)[0],
                  lang,
                )),
            );

        case "SEARCH":
          return api
            .defaultSession()
            .setResponseMode("JSON_ORIGINAL")
            .viewSearch(searchTerm)
            .setPlacements([placement])
            .load()
            .then(
              res =>
                (recommendationData = recommendations.transformRecPlacements(
                  Object.values(res.recommendations)[0],
                  lang,
                )),
            );

        case "CART":
          return api
            .defaultSession()
            .setResponseMode("JSON_ORIGINAL")
            .viewCart()
            .setPlacements([placement])
            .load()
            .then(
              res =>
                (recommendationData = recommendations.transformRecPlacements(
                  Object.values(res.recommendations)[0],
                  lang,
                )),
            );

        case "LANDING":
          return api
            .defaultSession()
            .setResponseMode("JSON_ORIGINAL")
            .viewFrontPage()
            .setPlacements([placement])
            .load()
            .then(
              res =>
                (recommendationData = recommendations.transformRecPlacements(
                  Object.values(res.recommendations)[0],
                  lang,
                )),
            );

        default:
          break;
      }
    }),
    isBrowser;

  $: recommendations.updatedRecommendations({
    ...recommendationData,
    pageType,
  }),
    recommendationData;

  $: cards = transformNostoRecsCards(recommendationData, lang);

  $: (show = cfg.NOSTO_SHOW_RECS && recommendationData?.products?.length > 0),
    recommendationData;
</script>

<style lang="scss">
  :global(.recommendation-carousel > div > .carousel) {
    padding: 0;
  }
  // .recommendation-carousel__cta {
  //   display: flex;
  //   justify-content: center;
  // }
</style>

{#key recommendationData}
  {#if show}
    <div
      class="recommendation-carousel"
      data-placement-id={recommendationData.resultId}
    >
      <Carousel
        recommendations
        id={recommendationData.resultId}
        size={CarouselSize.Four}
        title={$_(recommendationData.resultTitle)}
        {cards}
        {handleAttribution}
        quickBuy={true}
        headingElement="h2"
        total={recommendationData.products.length}
        key={recommendationData.resultId}
      >
        <!-- {#if cfg.REGION_ID === "uk" || cfg.REGION_ID === "de" || cfg.REGION_ID === "staging"}
          <div class="recommendation-carousel__cta">
            <Button
              primary
              label={$_("View More")}
              href={`./recommendations?id=${encodeURIComponent(
                recommendationData?.products?.map(product => product.productId),
              )}`}
            />
          </div>{/if} -->
      </Carousel>
    </div>
  {/if}
{/key}
